import React from 'react';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Box from '@material-ui/core/Box';
import FormLabel from '@material-ui/core/FormLabel';
import Paper from '@material-ui/core/Paper';

class DestSelector extends React.Component {
	constructor(props) {
		super(props);
		this.handleEdit = this.handleEdit.bind(this);
	}
	handleEdit(event) {
		this.props.handleChange(event.target.value);
	}
	render() {
		return (
			<Box my={1}>
				<Paper>
					<Box p={1}>
						<FormLabel component="legend">Destination</FormLabel>
						<Box p={1}>
							<RadioGroup row={true} value={this.props.value} onChange={this.handleEdit}>
								{this.props.destinations.map((element, index) =>
									<FormControlLabel key={index} label={element.label} value={element.value} control={<Radio/>}/>
								)}
							</RadioGroup>
						</Box>
					</Box>
				</Paper>
			</Box>
		);
	}
}

export default DestSelector;